import { useMemo } from 'react';
import Axios from 'axios';
import * as Routes from '@/modules/routes';
import serializeParams from '@/utils/serializeParams';
import useProgressiveLoad from '@/components/admin/SysadminSPA/shared/useProgressiveLoad';
import QueryKeys from '@/utils/QueryKeys';
import { versionToRows } from './auditLogRows';
import type { AuditRow, RawSubscriberVersion } from './auditLogRows';

interface VersionsPage {
  data: RawSubscriberVersion[];
  meta: { count: number };
}

const FETCH_PAGE_SIZE = 100;

const fetchPage = async (subscriberId: number, page: number): Promise<VersionsPage> => {
  const params = { page, per_page: FETCH_PAGE_SIZE };
  const url = `${Routes.plato_api_subscriber_subscriber_versions_path(subscriberId)}?${serializeParams(params)}`;
  const response = await Axios.get(url);

  return response.data;
};

const useSubscriberVersions = (subscriberId: number) => {
  const {
    data: versions, totalCount, isLoading, isFullyLoaded,
  } = useProgressiveLoad<RawSubscriberVersion, AuditRow[]>({
    fetchPage: page => fetchPage(subscriberId, page),
    queryKey: [QueryKeys.SubscriberVersions, subscriberId],
    transform: versionToRows,
  });

  const rows = useMemo(() => versions.flat(), [versions]);

  return {
    isFullyLoaded, isLoading, rows, totalCount,
  };
};

export default useSubscriberVersions;
